
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/residencies-fellowships",
      function () {
        return require("private-next-pages/residencies-fellowships/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/residencies-fellowships"])
      });
    }
  